const { default: Form } = require("./form")

let quizQuestions = {
    start: {
        id: 'start',
        title: 'Что вас интересует?',
        number: 1,
        answers: {
            1: {
                id: 'start-1',
                data: 'Изделие (камин, подоконник, столешница, барная стойка, ступени)',
                value: 'Изделие (камин, подоконник, столешница, барная стойка, ступени)',
                chain: ['selectBreed', 'stoneColor', 'deliveryAndAssembly', 'finish']
            },
            2: {
                id: 'start-2',
                data: 'Услуга облицовки',
                value: 'Услуга облицовки',
                chain: ['typeOfCladding', 'selectBreed', 'specifyProject', 'finish']
            },
        }
    },
    selectBreed: {
        id: 'selectBreed',
        number: 2,
        title: 'Выбери породу',
        answers: {
            1: {
                id: 'selectBreed-1',
                data: {pathThumb: './assets/images/granit-thumb.jpg', title: 'Гранит'},
                value: 'Гранит',
                template: 'breedCard'
            },
            6: {
                id: 'selectBreed-6',
                data: {pathThumb: './assets/images/kvarcevoj-aglomerat-thumb.jpg', title: 'Кварцевый Агломерат'},
                value: 'Кварцевый Агломерат',
                template: 'breedCard'
            },
            5: {
                id: 'selectBreed-5',
                data: {pathThumb: './assets/images/kvarcit-thumb.jpg', title: 'Кварцит'},
                value: 'Кварцит',
                template: 'breedCard'
            },
            2: {
                id: 'selectBreed-2',
                data: {pathThumb: './assets/images/mramor-thumb.jpg', title: 'Мрамор'},
                value: 'Мрамор',
                template: 'breedCard'
            },
            3: {
                id: 'selectBreed-3',
                data: {pathThumb: './assets/images/oniks-thumb.jpg', title: 'Оникс'},
                value: 'Оникс',
                template: 'breedCard'
            },
            4: {
                id: 'selectBreed-4',
                data: {pathThumb: './assets/images/travertin-thumb.jpg', title: 'Травертин'},
                value: 'Травертин',
                template: 'breedCard'
            },
        },        
        template: 'breedCardGrid'
    },
    stoneColor: {
        id: 'stoneColor',
        number: 3,
        title: 'Вы уже выбрали цвет камня?',
        answers: {
            1: {
                id: 'stoneColor-1',
                data: 'Да',
                value: 'Да',
            },
            2: {
                id: 'stoneColor-2',
                data: 'Нет, нужна помощь специалиста',
                value: 'Нет, нужна помощь специалиста',
            },
        },
    },
    deliveryAndAssembly: {
        id: 'deliveryAndAssembly',
        number: 4,
        title: 'Вам нужны доставка и монтаж?',
        answers: {
            1: {
                id: 'deliveryAndAssembly-1',
                data: 'Нужен монтаж и доставка',
                value: 'Нужен монтаж и доставка',
            },
            2: {
                id: 'deliveryAndAssembly-2',
                data: 'Только изготовление',
                value: 'Только изготовление',
            },
            3: {
                id: 'deliveryAndAssembly-3',
                data: 'Собственный вариант',
                value: '',
                template: 'radioText'
            },
        },
    },
    typeOfCladding: {
        id: 'typeOfCladding',
        number: 2,
        title: 'Укажите вид облицовки',
        answers: {
            1: {
                id: 'typeOfCladding-1',
                data: 'Полы, стены',
                value: 'Полы, стены',
            },
            2: {
                id: 'typeOfCladding-2',
                data: 'Цоколи, фасады',
                value: 'Цоколи, фасады',
            },
            3: {
                id: 'typeOfCladding-3',
                data: 'Крыльцо, входные группы',
                value: 'Крыльцо, входные группы',
            },
            4: {
                id: 'typeOfCladding-4',
                data: 'Другое',
                value: '',
                template: 'radioText'
            },
        },
    },
    specifyProject: {
        id: 'specifyProject',
        number: 3,
        title: 'Есть ли у вас размеры, проект или схема?',
        answers: {
            1: {
                id: 'specifyProject-1',
                data: 'Есть схема или проект',
                value: 'Есть схема или проект',
            },
            2: {
                id: 'specifyProject-2',
                data: 'Нужна помощь специалиста',
                value: 'Нужна помощь специалиста',
            },
        },
    },
    finish: {
        id: 'finish',
        template: 'finish',
        number: null,
        title: 'Оставьте контактные данные, чтобы мы могли связаться для детального расчета вашего заказа',
        answers: {

        },
    }
}

class QuizChain {

    constructor(quizQuestions) {

        this.popup = window.popup || null
        this.quizQuestions = quizQuestions

        const quizContainer = document.getElementById('quiz')
        const quizHeaderText = document.getElementById('quiz-header-text')
        const quizHeaderNumber = document.getElementById('quiz-header-number')
        const quizBodyTitle = document.getElementById('quiz-body-title')
        const quizBodyContent = document.getElementById('quiz-body-content')
        const quizFooter = document.getElementById('quiz-footer')
        const quizBtnPrev = document.getElementById('quiz-btn-prev')
        const quizBtnNext = document.getElementById('quiz-btn-next')
        const quizBtnSubmit = document.getElementById('quiz-btn-submit')
        const quizBtnClose = document.getElementById('quiz-btn-close')

        this.elements = {
            quizContainer,
            quizHeaderText,
            quizHeaderNumber,
            quizBodyTitle,
            quizBodyContent,
            quizFooter,
            quizBtnPrev,
            quizBtnNext,
            quizBtnSubmit,
            quizBtnClose
        }
        this.currentIndex = -1
        this.currentQuestionId = ''
        this.chain = []
        this.answers = {

        }

        // event handlers
        this.elements.quizBtnPrev.addEventListener('click', (e)=>this.prev())
        this.elements.quizBtnNext.addEventListener('click', (e)=>this.next())
        this.elements.quizBtnSubmit.addEventListener('click', (e)=>{
            const form = this.elements.quizBodyContent.querySelector('form')
            if (form) this.submitForm(form)
        })
        this.elements.quizBtnClose.addEventListener('click', (e)=>this.close())
    }

    templateBuilder(question) {
        const templates = {
            breedCard: (data, contentMarkup='')=>{
                const {pathThumb, title, id} = data
                const alt = (pathThumb) ? pathThumb.split('/').pop().split(0, -4) : '' 
                let active = '' 
                if ( this.answers[questionId] && this.answers[questionId] === id ) {
                    active = 'active'
                    this.processAnswer(id)
                }      
                const template = `
                    <div class="materials__card material-card ${active}" data-quiz-card>
                        <div class="image-wrap material-card__image-wrap">
                            <div class="image-ratio material-card__image-ratio">
                                <img class="image material-card__image" src="${pathThumb}" alt="${alt}">
                            </div>
                        </div>
                        <p class="material-card__title">${title}</p>
                        <a class="material-card__layout-link" href="#" onClick="event.preventDefault(); quizSetActiveCard(this); quizSelectHandler('${id}')"></a>
                    </div>
                `

                return template
            },
            breedCardGrid: (data=null, contentMarkup='')=>{
                const template = `
                    <div class="quiz__content-grid">
                        <input id="quiz-answer" type="hidden" value="">
                        ${contentMarkup}
                    </div>
                `
    
                return template
            },
            radioText: (data, contentMarkup='')=>{
                const {text, value, id} = data
                const [questionId, answerKey] = id.split('-')
                let checked = ''
                let disabled = 'disabled'
                if ( this.answers[questionId] && this.answers[questionId] === id ) {
                    checked = 'checked'
                    disabled = ''
                    this.processAnswer(id)
                }
                // if (this.answers)
                const template = `
                    <div class="quiz-radio-wrap">
                        <input
                            class="quiz__radio"
                            type="radio" id="${id}"
                            name="answer"
                            value="${value}"
                            onChange="quizSelectHandler('${id}')"
                            ${checked} />
                        <label class="quiz__radio-label" for="${id}">${text}</label>
                        <input data-input="${id}" onInput="setAnswerValue(this, '${id}')" value="${value}" class="quiz__input-text" type="text" placeholder="" ${disabled} />
                    </div>
                `

                return template
            },
            defaultQuestionTemplate: (data=null, contentMarkup='')=>{
                const template = `
                    <div class="quiz__content-list">
                        ${contentMarkup}
                    </div>
                `
    
                return template
            },
            defaultAnswerTemplate: (data, contentMarkup='')=>{
                const {text, value, id} = data
                let checked = ''
                if ( this.answers[questionId] && this.answers[questionId] === id ) {
                    checked = 'checked'
                    this.processAnswer(id)
                }
                const template = `
                    <div class="quiz-radio-wrap">
                        <input
                            class="quiz__radio"
                            type="radio" id="${id}"
                            name="answer"
                            value="${value}"
                            onChange="quizSelectHandler('${id}')"
                            ${checked} />
                        <label class="quiz__radio-label" for="${id}">${text}</label>
                    </div>
                `
    
                return template
            },
            finish: (data=null, contentMarkup='')=>{
                const template = `
                    <form class="quiz__form" action="/ajax/" method="POST">
                        <div class="quiz__content-list">
                            <div class="quiz-radio-wrap">
                                <div class="quiz-input-wrap">
                                    <input
                                        class="quiz__input-text"
                                        type="text"
                                        required
                                        name="name"
                                        placeholder="Имя"
                                    />
                                </div>
                                <div class="quiz-input-wrap">
                                    <input
                                        class="quiz__input-text"
                                        type="text"
                                        required
                                        name="phone"
                                        placeholder="Телефон"
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                `
    
                return template
            },
        }
    
        const questionId = question.id
        const questionTemplateName = question.template || 'defaultQuestionTemplate'
        if (!templates[questionTemplateName]) {
            console.error(`template name ${questionTemplateName} is undefined`)
            return ''
        }
        
        const contentMarkup = Object.entries(question.answers).reduce((prev, next)=>{
            const [key, answer] = next
            if (!answer.id) answer.id = `${questionId}-${key}`
            const templateName = answer.template || 'defaultAnswerTemplate' 
            let data = {
                value: answer.value,
                id: answer.id
            }
            if (typeof answer.data === 'string') {
                data.text = answer.data
            } else {
                data = {...data, ...answer.data}
            }
            return prev + templates[templateName](data)
        }, '')
        const questionTemplate = templates[questionTemplateName]( null,  contentMarkup )
        return questionTemplate
    }

    setHeaderText(markup) {
        this.elements.quizHeaderText.innerHTML = markup
    }

    setHeaderNumber(markup) {
        this.elements.quizHeaderNumber.innerHTML = markup
    }

    setBodyTitle(markup) {
        this.elements.quizBodyTitle.innerHTML = markup
    }

    setBodyContent(markup) {
        this.elements.quizBodyContent.innerHTML = markup
    }

    setBtnDisabled(btnId, status) {
        let btn = null
        if (btnId === 'prev') {
            btn = this.elements.quizBtnPrev
        } else if (btnId === 'next') {
            btn = this.elements.quizBtnNext
        } else {
            console.error(`unknown btn id ${btnId}`)
            return false
        }

        if (status) {
            btn.setAttribute('disabled', 'disabled')
        } else {            
            btn.removeAttribute('disabled')
        }
    }

    render(questionId='start') {
        if (this.quizQuestions[questionId] === undefined) {
            console.error(`question ${questionId} not found`)
        }

        const question = this.quizQuestions[questionId]
        if (!question.id) {
            question.id = questionId
        }

        const headerText = question.header || 'Ответьте на 4 коротких вопроса и получите персональный детальный расчет стоимости'
        const headerNumber = question.number ? `${this.currentIndex + 1}/4` : ''
        const bodyTitle = question.title
        const bodyContentMarkup = this.templateBuilder( question )
        this.setHeaderText(headerText)
        this.setHeaderNumber(headerNumber)
        this.setBodyTitle(bodyTitle)
        this.setBodyContent(bodyContentMarkup)
    
        if (question.id === 'start') {
            this.setBtnDisabled('prev', true)
        } else {
            this.setBtnDisabled('prev', false)
        }
    
        if (question.id === 'finish') {
            this.setBtnDisabled('next', true)
            this.elements.quizFooter.classList.add('finish')
        } else {
            this.setBtnDisabled('next', false)
            this.elements.quizFooter.classList.remove('finish')
        }
    
        if (!this.validate(question.id)) this.setBtnDisabled('next', true)

        this.currentQuestionId = question.id
        if (!this.chain.length) {
            this.chain.push(question.id)
            this.currentIndex = 0
        }

        this.elements.quizContainer.classList.add('show')
    }

    processAnswer(answerId) {
        const [questionId, answerKey] = answerId.split('-')
        const answer = this.getAnswerById(answerId)
        this.setChain(answer)
        this.setStorageItem(questionId, answerId)
        if (this.validate(questionId)) {
            this.setBtnDisabled('next', false)
        } else {
            this.setBtnDisabled('next', true)
        }
        const radioInputs = Array.from( this.elements.quizBodyContent.querySelectorAll('[data-input]') )
        radioInputs.forEach(input => {
            const inputAnswerId = input.dataset.input
            if (inputAnswerId !== answerId) {
                input.setAttribute('disabled', 'disabled')
            } else {
                input.removeAttribute('disabled')
            }
        })
    }

    setStorageItem(key, value) {
        this.answers[key] = value
    }

    setChain(answer) {
        const beforeChain = this.chain.slice(0, this.currentIndex + 1)
        const afterChain = answer.chain
        if (afterChain && afterChain.length) {
            this.chain = [...beforeChain, ...afterChain]
        }
    }

    setAnswerValue(answerId, value) {
        const answer = this.getAnswerById(answerId)
        answer.value = value
        this.processAnswer(answerId)
    }

    getAnswerById(answerId) {
        const [questionId, answerKey] = answerId.split('-')
        const answer = this.quizQuestions[questionId].answers[answerKey]
        return answer
    }

    validate(questionId) {
        if (!this.answers[questionId]) return false
        const answer = this.getAnswerById( this.answers[questionId] )
        if (!answer) return false
        const value = answer.value
        return !!value
    }

    setCurrentIndex(index) {
        this.currentIndex = index
        this.currentQuestionId = this.chain[this.currentIndex]
    }

    prev() {
        if (this.currentIndex <= 0) {
            console.info('позади вопросов нет')
            return
        }
        this.setCurrentIndex( this.currentIndex - 1 )
        this.render(this.currentQuestionId)
    }

    next() {
        if (this.currentIndex >= this.chain.length) {
            console.info('впереди вопросов нет')
            return
        }
        this.setCurrentIndex( this.currentIndex + 1 )
        this.render(this.currentQuestionId)
    }

    submitForm(form) {
        const formjs = new Form(form, {
            action: 'quiz',
            url: form.getAttribute('action'),
            error_classname: 'form__error'
        })

        if (!formjs.validate()) {
            return false
        }

        const body = formjs.serialize()
        const answers = Object.entries(this.answers).map((entry, index) => {
            const [questionId, answerId] = entry
            const question = this.quizQuestions[questionId].title
            const answer = this.getAnswerById(answerId)
            return `${index + 1}. ${question}: \n\t ${answer.value}`
        })
        body.append('answers', JSON.stringify(answers))
        body.append('action', formjs.options.action)

        fetch(formjs.options.url, {
            method: 'POST',
            body 
        })
            .then((response) => {
                if (response.status > 200) {
                    throw new Error(`${response.status}`)
                }
                return response.json()
            })
            .then(response => {

                let title = ''
                let message = ''
                if (response.status) {
                    title = (response.title) ? response.title : 'Успех'
                    message = (response.message) ? response.message : 'Форма успешно отправлена'

                } else {
                    title = response.errors[0]['title'] || 'Ошибка'
                    message = response.errors[0]['message']
                }

                this.close()

                if (this.popup) {
                    this.popup.set({title, message})
                    this.popup.open()
                }
                if (this.setPreloader) this.setPreloader(false)
            })
            .catch(err => {
                console.error(err)
                if (window.popup) {
                    window.popup.set({title: 'Ошибка', message: err})
                    window.popup.open()
                }
                this.close()
            })
    }

    close() {
        this.elements.quizContainer.classList.remove('show')
        this.currentIndex = -1
        this.currentQuestionId = ''
        this.chain = []
        this.answers = {

        }
    }
}

export function quizInit() {
    const quizChain = new QuizChain(quizQuestions)
    // window.quizChain = quizChain
    window.quizStart = ()=>{
        quizChain.render('start')
    }
    window.quizSelectHandler = (answerId, ...args)=> {
        quizChain.processAnswer(answerId)
    }
    window.quizSetActiveCard = (target) => {
        const currentCard = target.closest('[data-quiz-card]')
        if (!currentCard) return
        const activeCard = currentCard.parentElement.querySelector('[data-quiz-card].active')
        if (activeCard) activeCard.classList.remove('active')
        currentCard.classList.add('active')
    }
    window.setAnswerValue = (target, answerId) => {
        quizChain.setAnswerValue(answerId, target.value)
    }
}
